<form autocomplete="off" #form="ngForm" *ngIf="prestation && isLoaded">
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.generalites.infosGenerales.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="libelle"
                                  name="libelle"
                                  [(ngModel)]="prestation.libelle"
                                  customType="input"
                                  maxlength="50"
                                  libelle="admin.frais.prestations.detail.generalites.infosGenerales.libelle"
                                  [required]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="isActif"
                                  name="isActif"
                                  [ngModel]="prestation.actif"
                                  [(customModel)]="prestation.actif"
                                  customType="checkbox"
                                  libelle="admin.frais.prestations.detail.generalites.infosGenerales.actif">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="code"
                                  name="code"
                                  [(ngModel)]="prestation.code"
                                  customType="input"
                                  maxlength="100"
                                  libelle="admin.frais.prestations.detail.generalites.infosGenerales.code"
                                  [required]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  id="icone"
                                  name="icone"
                                  [(ngModel)]="prestation.icone"
                                  [selectOptions]="listeIcones"
                                  customType="select"
                                  optionDisplay="libelle"
                                  optionValue="type"
                                  optionIcone="icone"
                                  libelle="admin.frais.prestations.detail.generalites.infosGenerales.icone"
                                  [required]="true">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  #famille
                                  id="famille"
                                  name="famille"
                                  [(ngModel)]="selectedFamille"
                                  [selectOptions]="listeFamille"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="id"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="true"
                                  libelle="admin.frais.prestations.detail.generalites.infosGenerales.famille"
                                  (onChange)="onFamilleChange()">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  #type
                                  id="type"
                                  name="type"
                                  [(ngModel)]="selectedTypePrestation"
                                  [selectOptions]="listeTypePrestation"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="id"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="true"
                                  libelle="admin.frais.prestations.detail.generalites.infosGenerales.type"
                                  (onChange)="onTypePrestationChange()">
                    </custom-input>
                </div>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="nature"
                                  name="nature"
                                  [(ngModel)]="prestation.nature"
                                  customType="input"
                                  maxlength="10"
                                  libelle="admin.frais.prestations.detail.generalites.infosGenerales.nature">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.generalites.donneesComptables.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="compte"
                                  name="compte"
                                  [(ngModel)]="selectedCompteCharge"
                                  [selectOptions]="listeCompteCharge"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="displayName"
                                  optionValue="numero"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="false"
                                  [addElementClick]="addCompteChargeClick"
                                  libelle="admin.frais.prestations.detail.generalites.donneesComptables.compteCharge.title"
                                  (onChange)="onCompteChargeChange()"
                                  [required]="true">
                    </custom-input>
                    <custom-input ngDefaultControl
                                  #liasse
                                  id="liasse"
                                  name="liasse"
                                  [(ngModel)]="selectedCodeLiasse"
                                  [selectOptions]="listeCodeLiasse"
                                  [valeurIdTampon]="'objetTampon'"
                                  customType="objectselect"
                                  optionDisplay="libelle"
                                  optionValue="id"
                                  [isSelectAvecVide]="false"
                                  [isSelectAvecInput]="true"
                                  libelle="admin.frais.prestations.detail.generalites.donneesComptables.codeLiasse"
                                  (onChange)="onCodeLiasseChange()">
                    </custom-input>
                </div>
                <zone-predefinie [listeFieldParam]="listeFieldParam" [fieldContainer]="fieldContainer" [isDisableInactive]="true"></zone-predefinie>
            </fieldset>
        </mat-card-content>
    </mat-card>
    <mat-card>
        <mat-card-title>
            <span>{{'admin.frais.prestations.detail.generalites.infosComplementaires.title' | translate}}</span>
        </mat-card-title>
        <mat-card-content>
            <fieldset>
                <div class="row">
                    <custom-input ngDefaultControl
                                  id="commentaire"
                                  name="commentaire"
                                  [(ngModel)]="prestation.remarque"
                                  customType="textarea"
                                  rCol="10"
                                  libelle="admin.frais.prestations.detail.generalites.infosComplementaires.commentaire">
                    </custom-input>
                </div>
            </fieldset>
        </mat-card-content>
    </mat-card>
</form>